import React from "react"
import Skeleton from "react-loading-skeleton"
import {IcomoonIconName} from "../Icon/icons"
import Icon from "../Icon/Icon"

export type TagTheme = "info" | "error" | "success" | "warning" | "neutral" | "dark"

export type BadgeProps = {
	icon?: IcomoonIconName
	content: string | React.ReactNode
	loading?: boolean
	variant: "outline" | "filled"
	theme: TagTheme
	size: "small" | "large"
}

export function Tag({content, loading, icon, variant, theme, size}: BadgeProps) {
	return (
		<>
			{loading ? (
				<Skeleton width={55} height={18} />
			) : (
				<span className={`unit-tag ${variant} ${theme} ${size}`}>
					{icon && <Icon icon={icon} size={12} />} {content}
				</span>
			)}
		</>
	)
}

export default Tag
